import * as yup from "yup";
const emailValidation = yup
  .string()
  .test("email", "Invalid email", function (value) {
    if (!value) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  })
  .required("Email is required");

export const loginValidation = yup.object({
  email: emailValidation,
  password: yup.string().required("Password is required"),
});

export const forgotPasswordValidation = yup.object({
  email: emailValidation,
});

export const resetPasswordValidation = yup.object({
  password: yup.string().required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords don't match.")
    .required("Password is required")
    .min(6, "Password should be atleast 6 characters"),
});

export const changePasswordValidation = yup.object({
  oldPassword: yup.string().required("Old password is required"),
  newPassword: yup.string().required("New password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords don't match.")
    .required("Confirm Password is required"),
});

export const profileValidation = yup.object({
  name: yup.string().required("Name is required"),
  email: emailValidation,
  phone: yup
    .string()
    .required("Phone is required")
    .min(9)
    .max(14)
    .matches(/^\d+$/, "Phone number must consist of digits only"),
});

export const sendEmailValidation = yup.object({
  subject: yup.string().required("Subject is required"),
  message: yup.string().required("Message is required"),
});

export const ticketValidation = yup.object({
  message: yup.string().required("Message is required"),
});

export const promocodeValidation = yup.object({
  name: yup.string().required("Promocode name is required"),
  discount: yup
    .number()
    .typeError("Please enter a valid number")
    .required("Discount is required"),
  startDate: yup.string(),
  endDate: yup.string().required("Expiry Date is required"),
  usageLimit: yup
    .number()
    .typeError("Please enter a valid number")
    .required("Usage Limit is required"),
  categoryIds: yup
    .array()
    .min(1, "Category is required")
    .required("Category is required"),
  description: yup.string(),
});

export const generateInvoiceValidation = yup.object({
  startDate: yup.string().required("Start Date is required"),
  endDate: yup.string().required("End Date is required"),
  paymentStatus: yup.string().required("Status is Required"),
});

export const refundAmountValidation = yup.object({
  amount: yup
    .number()
    .typeError("Please enter amount")
    .required("Please enter amount"),
});
